import { observer } from 'mobx-react-lite';
import React, { FC } from 'react'
import { useNavigate } from 'react-router-dom';


const ForSpecialistsRecs: FC = () => {

    const navigate = useNavigate()

    return (
        <div className='row pt-2 m-3'>
            <h6 className='p-3 text-center'>Рекомендации для специалистов</h6>
            <div className='col-md-3 text-center' onClick={() => navigate('/specialist/recs/1/')} style={{ cursor: 'pointer' }}>
                <img src="/images/1.2.webp" alt="" className="img_wrap2"/>
                <p className='text-center fw-bold text-uppercase'>Нарушения зрения</p>
            </div>
            <div className='col-md-3 text-center' onClick={() => navigate('/specialist/recs/2/')} style={{ cursor: 'pointer' }}>
                <img src="/images/2.2.webp" alt="" className="img_wrap2"/>
                <p className='text-center fw-bold text-uppercase'>Нарушения слуха</p>
            </div>
            <div className='col-md-3 text-center' onClick={() => navigate('/specialist/recs/3/')} style={{ cursor: 'pointer' }}>
                <img src="/images/3.2.webp" alt="" className="img_wrap2"/>
                <p className='text-center fw-bold text-uppercase'>Нарушения речи</p>
            </div>
            <div className='col-md-3 text-center' onClick={() => navigate('/specialist/recs/4/')} style={{ cursor: 'pointer' }}>
                <img src="/images/4.2.webp" alt="" className="img_wrap2"/>
                <p className='text-center fw-bold text-uppercase'>Нарушения опорно-двигательного аппарата</p>
            </div>
            <div className='col-md-3 text-center' onClick={() => navigate('/specialist/recs/5/')} style={{ cursor: 'pointer' }}>
                <img src="/images/5.2.webp" alt="" className="img_wrap2"/>
                <p className='text-center fw-bold text-uppercase'>Задержки психического развития</p>
            </div>
            <div className='col-md-3 text-center' onClick={() => navigate('/specialist/recs/6/')} style={{ cursor: 'pointer' }}>
                <img src="/images/6.2.webp" alt="" className="img_wrap2"/>
                <p className='text-center fw-bold text-uppercase'>Нарушения интеллекта</p>
            </div>
            <div className='col-md-3 text-center' onClick={() => navigate('/specialist/recs/7/')} style={{ cursor: 'pointer' }}>
                <img src="/images/7.2.webp" alt="" className="img_wrap2"/>
                <p className='text-center fw-bold text-uppercase'>Расстройства аутистического спектра</p>
            </div>
            <div className='col-md-3 text-center' onClick={() => navigate('/specialist/recs/8/')} style={{ cursor: 'pointer' }}>
                <img src="/images/8.2.webp" alt="" className="img_wrap2"/>
                <p className='text-center fw-bold text-uppercase'>Другие заболевания</p>
            </div>
        </div>
    );
};

export default observer(ForSpecialistsRecs);